import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Guarantee() {
  return <section className="w-full bg-cobalt/10 px-5 py-12 sm:py-20" data-id="element-92" data-mp="223eltma3nb3z">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.5
    }} className="mx-auto flex max-w-2xl flex-col items-center rounded-2xl border border-cobalt/40 bg-white/70 p-8 text-center sm:p-12" data-id="element-93" data-mp="222n2b9ts13u2">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-cobalt/15 text-cobalt-deep" data-id="element-94" data-mp="1j4k8mhqaaipx">
          <ShieldCheckIcon className="h-9 w-9" aria-hidden="true" data-id="element-95" data-mp="1ee3qikbiq8x8" />
        </span>
        <h2 className="mt-5 font-serif-display text-2xl font-bold text-ink sm:text-3xl" data-id="element-96" data-mp="qo9j4i9yxckd">
          Garanzia di rimborso di 7 giorni
        </h2>
        <div className="mt-6 space-y-4 text-sm leading-relaxed text-ink/75 sm:text-base" data-id="element-97" data-mp="lo4wsbmdpnm8">
          <p data-id="element-98" data-mp="oygm6gi8jgbc">
            Esplora i materiali con tranquillità. Qualora CHIMICA VISIVA™ non fosse adatto alle
            esigenze della tua classe, potrai contattarci entro sette giorni dall’acquisto e
            richiedere il rimborso secondo le condizioni indicate nella nostra politica di rimborso.
          </p>
        </div>
        <div className="mt-8 w-full max-w-md" data-id="element-99" data-mp="12q4wce8xbupo">
          <CTAButton label="SÌ, VOGLIO IL SISTEMA COMPLETO" data-id="element-100" data-mp="6171yx535yt1" />
        </div>
      </motion.div>
    </section>;
}